import { render, staticRenderFns } from "./fangxin.vue?vue&type=template&id=3f90edd4&scoped=true&"
import script from "./fangxin.vue?vue&type=script&lang=js&"
export * from "./fangxin.vue?vue&type=script&lang=js&"
import style0 from "./fangxin.vue?vue&type=style&index=0&id=3f90edd4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f90edd4",
  null
  
)

export default component.exports